import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError} from 'rxjs';
import {ExceptionHandlingService} from '../services/exception-handling.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const exceptionHandler = inject(ExceptionHandlingService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) =>
            exceptionHandler.handle(error)
        )
    );
};
